import { ValidationErrorMessage } from './constants/validation-error.message';
import { TValidatorResponse } from './types/validator-response.types';

export const isLessOrEqual =
	(maxValue: number) =>
	(value: string): TValidatorResponse => {
		const numberValue = Number(value);
		return numberValue <= maxValue ? undefined : ValidationErrorMessage.ValueShouldBeLessOrEqual(maxValue);
	};